/* tslint:disable */
/* eslint-disable */
/**
 * Explorer API Needs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @enum {string}
 */

export enum NotificationActionCategoryDTO {
    GuildInvitationApprove = 'GUILD_INVITATION_APPROVE',
    GuildInvitationReject = 'GUILD_INVITATION_REJECT',
    ServiceRequestQuotationUpdate = 'SERVICE_REQUEST_QUOTATION_UPDATE',
    ServiceRequestView = 'SERVICE_REQUEST_VIEW'
}


/**
 * 
 * @export
 * @interface NotificationActionDTO
 */
export interface NotificationActionDTO {
    /**
     * 
     * @type {string}
     * @memberof NotificationActionDTO
     */
    'id'?: string;
    /**
     * 
     * @type {NotificationActionCategoryDTO}
     * @memberof NotificationActionDTO
     */
    'category': NotificationActionCategoryDTO;
    /**
     * 
     * @type {Array<NotificationParameterDTO>}
     * @memberof NotificationActionDTO
     */
    'parameters'?: Array<NotificationParameterDTO>;
    /**
     * 
     * @type {boolean}
     * @memberof NotificationActionDTO
     */
    'performed': boolean;
}


/**
 * 
 * @export
 * @enum {string}
 */

export enum NotificationCategoryDTO {
    GuildCreationApproved = 'GUILD_CREATION_APPROVED',
    GuildCreationDenied = 'GUILD_CREATION_DENIED',
    GuildUserInvitation = 'GUILD_USER_INVITATION',
    UserRemovedFromGuild = 'USER_REMOVED_FROM_GUILD',
    ServiceRequestCompleted = 'SERVICE_REQUEST_COMPLETED',
    ServiceRequestQuotationUpdate = 'SERVICE_REQUEST_QUOTATION_UPDATE',
    ServiceRequestCreated = 'SERVICE_REQUEST_CREATED'
}


/**
 * A notification object used to read notifications from the backend
 * @export
 * @interface NotificationDTO
 */
export interface NotificationDTO {
    /**
     * 
     * @type {string}
     * @memberof NotificationDTO
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof NotificationDTO
     */
    'content'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof NotificationDTO
     */
    'read': boolean;
    /**
     * 
     * @type {string}
     * @memberof NotificationDTO
     */
    'recipientOauthId': string;
    /**
     * 
     * @type {NotificationCategoryDTO}
     * @memberof NotificationDTO
     */
    'category': NotificationCategoryDTO;
    /**
     * 
     * @type {Array<NotificationActionDTO>}
     * @memberof NotificationDTO
     */
    'notificationActions'?: Array<NotificationActionDTO>;
    /**
     * 
     * @type {Array<NotificationParameterDTO>}
     * @memberof NotificationDTO
     */
    'parameters'?: Array<NotificationParameterDTO>;
    /**
     * 
     * @type {string}
     * @memberof NotificationDTO
     */
    'createdDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationDTO
     */
    'updatedDate'?: string;
}


/**
 * A key value pair to use as additional parameter in a notification
 * @export
 * @interface NotificationParameterDTO
 */
export interface NotificationParameterDTO {
    /**
     * Any name used for a parameter
     * @type {string}
     * @memberof NotificationParameterDTO
     */
    'label': string;
    /**
     * the value of the parameter
     * @type {string}
     * @memberof NotificationParameterDTO
     */
    'value': string;
}

